<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
  )
    option(value="" disabled selected) {{ $t("message.select_option") }}
    option(
      v-for="option in options"
      :value="getDDLValue(option)"
    ) {{ option.bank_name }} - {{ option.bank_acc_no }} - {{ option.account_id }} ({{ $n(option.account_balance, 'currency') }})
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    filterBalance: {
      type: Boolean,
      default: false
    },
    operatorID: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    options: [],
    feedback: {
      success: true,
      status: ""
    }
  }),
  mounted: function() {
    this.getBankAccList();
  },
  methods: {
    getDDLValue: function(obj) {
      return obj.bank_id.toUpperCase().trim() + ' - ' + obj.bank_acc_no.toUpperCase().trim() + ' - ' + obj.account_id.toUpperCase().trim() + ' - ' + obj.account_balance.toString().toUpperCase().trim();
    },
    getBankAccList: function() {
      let url = config.bankListWithdrawalUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.options = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
